import * as landRegistryActions from '../../actions/landRegistry';
import landRegistryStore from '../../stores/landRegistry';
import i18nMixin from '../i18nMixin';
import * as tagStatesMixin from '../tagStatesMixin';
import { library } from '@fortawesome/fontawesome-svg-core';
import { coreStore } from '@ambita/ambita-components-core';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
library.add(faInfoCircle);

const ALLOWED_PANTEBOK_REPORT_CHANNELS = ['NYEINFOLAND', 'NYEINFOLAND_CARD_1F4B3'];

const nestingSymbol = function (nestingLevel) {
  return Array(nestingLevel + 1).join('** ');
};

const sizeOfMap = function (map) {
  if (!map) {
    return 0;
  }

  return Object.keys(map).length;
};

const getTextItemClasses = function (textItem) {
  let classes = '';

  if (textItem.bold === true) {
    classes += 'ambita-bold ';
  }

  return classes;
};

export const init = (tag): void => {
  tag.mixin(tagStatesMixin);
  tag.mixin(i18nMixin);

  const updateState = function (): void {
    const landRegistryPartName = tag.opts.landRegistryPart;
    const landRegistryState = tag.opts.landRegistryState;

    if (!landRegistryPartName || !landRegistryState) {
      return;
    }

    const previousTagState = tag.state;
    const documentData = landRegistryStore.getLandRegistryPart(landRegistryPartName, landRegistryState);

    tag.updateState(documentData.status);

    if (documentData.error) {
      tag.error = documentData.error;
    } else if (documentData.data) {
      tag.dataFetchedAtTime = documentData.data.timeFetched;
      tag.item = documentData.data.item;
      tag.knr = documentData.data.knr;

      if (tag.item) {
        tag.propertyKey = tag.item.cadastreKey;
      }
    }

    if ((previousTagState !== documentData.status) &&
      (documentData.status === tag.states.DONE_SUCCESS || tag.state === tag.states.DONE_ERROR)) {
      landRegistryActions.registerTagLoadingFinished(landRegistryPartName, landRegistryState);
    }

    tag.update();
  };

  tag.nestingSymbol = nestingSymbol;
  tag.sizeOfMap = sizeOfMap;
  tag.getTextItemClasses = getTextItemClasses;

  tag.on('mount', async () => {
    const clientId = await coreStore.getClientId();

    const isChannelAllowed = ALLOWED_PANTEBOK_REPORT_CHANNELS.includes(clientId);
    tag.purchaseAllowed = isChannelAllowed;
    tag.update();

    updateState();
    landRegistryStore.subscribe(updateState);
  });

  tag.on('unmount', () => {
    landRegistryStore.unsubscribe(updateState);
  });
};
